// 秒杀进度条功能
class SeckillProgress {
  constructor () {
    this.seckillContainer = document.getElementById('seckillContainer')
    this.progressBar = document.getElementById('progressBar')
    this.progressPercentage = document.getElementById('progressPercentage')

    this.elDay = document.getElementById('seckillDay')
    this.elHour = document.getElementById('seckillHour')
    this.elMinute = document.getElementById('seckillMinute')
    this.elSecond = document.getElementById('seckillSecond')

    this.progressRate = this.seckillContainer.dataset.rate
    this.seckillTime = this.seckillContainer.dataset.time

    this.init()
  }

  init () {
    this.updateCountdown()
    // this.startProgressAnimation();
    this.createSparkles()
    setInterval(() => {
      this.updateCountdown()
    }, 1000)
  }

  createSparkles () {
    setInterval(() => {
      const sparkle = document.createElement('div')
      sparkle.className = 'sparkle'
      sparkle.style.left = Math.random() * 100 + '%'
      sparkle.style.top = Math.random() * 100 + '%'
      sparkle.style.animationDelay = Math.random() * 2 + 's'

      this.progressBar.appendChild(sparkle)

      setTimeout(() => {
        if (sparkle.parentNode) {
          sparkle.parentNode.removeChild(sparkle)
        }
      }, 2000)
    }, 500)
  }

  updateCountdown () {
    const seckillTime = new Date(this.seckillTime)
    const now = new Date()
    const timeDiff = seckillTime - now

    if (timeDiff <= 0) {
      this.elDay.textContent = '00'
      this.elHour.textContent = '00'
      this.elMinute.textContent = '00'
      this.elSecond.textContent = '00'
      return
    }

    if (timeDiff > 0) {
      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      )
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000)

      this.elDay.textContent = days
      this.elHour.textContent = hours
      this.elMinute.textContent = minutes < 10 ? `0${minutes}` : minutes
      this.elSecond.textContent = seconds < 10 ? `0${seconds}` : seconds
    }
  }
}

// 页面加载完成后初始化
document.addEventListener('DOMContentLoaded', () => {
  new SeckillProgress()
})
